import Vue from 'vue'
import Router from 'vue-router'

//routes
import horizontalRoutes from './horizontal'

// session components
// const SignUpOne = () => import('Views/session/SignUpOne')
const LoginOne = () => import('Views/session/LoginOne')
const LockScreen = () => import('Views/session/LockScreen')
const ForgotPassword = () => import('Views/session/ForgotPassword')
const ResetPassword = () => import('Views/session/ResetPassword')


// Errors


Vue.use(Router)

export default new Router({
	// mode: 'history',
	routes: [
		horizontalRoutes,
		{
			path: '/auth/login',
			name: 'auth.login',
			component: LoginOne,
			meta: {
				title: 'message.login',
				breadcrumb: 'Session / Login'
			}
		},
		{
			path: '/auth/lock-screen',
			component: LockScreen,
			meta: {
				title: 'Lock Screen',
				breadcrumb: 'Session / Lock Screen'
			}
		},
		{
			path: '/session/forgot-password',
			component: ForgotPassword,
			meta: {
				title: 'message.forgotPassword',
				breadcrumb: 'Session / Forgot Password'
			}
		},
		{
			path: '/session/reset-password',
			component: ResetPassword,
			meta: {
				title: 'message.resetPassword',
				breadcrumb: 'Session / Reset Password'
			}
		}
	]
})
